<template>
  <div class="spinner">
    <div class="spinner__element"></div>
  </div>
</template>

<script src='./index.js'></script>
<style lang="scss" scoped src="./index.scss"></style>
